<script>
import Layout from "../../../layouts/main";
import 'vue2-datepicker/index.css';
import TongSoApexChart from "@/pages/quantri/dashboard/tongSoApexChart";
import TongSoDanhGiaApexChart from "@/pages/quantri/dashboard/tongSoDanhGiaApexChart";


export default {
  page: {
    title: "Dashboard - CHATBOT",
  },
  components: {
    TongSoApexChart,
    TongSoDanhGiaApexChart,
    Layout ,
  },
  data() {
    return {
      model: null,
      title: "Dự án",
      soLieu: {
      tongSoCauHoi: 0,
        tongSoChatBox: 0,
        tongSoDichVuCong: 0,
        tongSoUngDungKhac: 0
      },
      menu : []
    }
  },
  created() {
    this.getAll();
  },
  methods:{
    async getAll() {
      await this.$store.dispatch("statisticalStore/getAll").then((res) => {
        console.log("LOG DATA : ",res.data )
        this.soLieu = res.data || [];
      })
    },
  }
}
</script>
<template>
  <Layout>
    <div class="row equal-height-row mb-0">
      <!-- Dự án-->
      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid cs-stats cs-all-project" style="border-radius: 10px;">
          <div class="card-body card-1">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="fw-medium mb-2 cs-title">Tổng số câu hỏi</p>
                <h4 class="mb-0 cs-total text-w">{{soLieu.tongSoCauHoi}}</h4>
              </div>
              <div class="avatar-sm align-self-center rounded-circle ic-all-project">
                          <span class="avatar-title avt-1">
                            <i class="bx bx-briefcase-alt-2 font-size-24"></i>
                          </span>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- Dự án hoàng thành-->
      <div class="col-xl-3 col-md-6">
        <div class="card cs-stats cs-project-complete" style="border-radius: 10px;">
          <div class="card-body card-2">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="fw-medium mb-2">CHATBOX</p>
                <h4 class="mb-0 text-w">{{soLieu.tongSoChatBox}}</h4>
              </div>

              <div class="avatar-sm align-self-center ic-project-complete">
                          <span class="avatar-title avt-2">
                            <i class="bx bx-task font-size-24"></i>
                          </span>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- Dự án trễ hẹn-->
      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid cs-stats cs-project-delay" style="border-radius: 10px;">
          <div class="card-body card-3">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="fw-medium mb-2">DỊCH VỤ CÔNG</p>
                <h4 class="mb-0 text-w">{{soLieu.tongSoDichVuCong}}</h4>
              </div>

              <div class="avatar-sm align-self-center rounded-circle ic-project-delay">
                          <span class="avatar-title avt-3">
                            <i class="bx bx-time font-size-24"></i>
                          </span>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- Khó khăn -->
      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid cs-stats cs-project-difficult" style="border-radius: 10px;">
          <div class="card-body card-4">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="fw-medium mb-2">ỨNG DỤNG KHÁC</p>
                <h4 class="mb-0 text-w">{{this.soLieu.tongSoUngDungKhac}}</h4>
              </div>

              <div class="avatar-sm align-self-center ic-project-difficult rounded-circle">
                          <span class="avatar-title avt-4">
                            <i class="bx bx-wrench font-size-24"></i>
                          </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <tong-so-apex-chart/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <tong-so-danh-gia-apex-chart/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">

        </div>
      </div>
    </div>
    <div>
    </div>
  </Layout>
</template>
<style>
.card-1{
  background-color: #5473e7;
  padding: 30px 20px;
  border-radius: 10px;
}
.card-2{
  background-color: #5ecdc2;
  padding: 30px 20px;
  border-radius: 10px;
}
.card-3{
  background-color: #e28958;
  padding: 30px 20px;
  border-radius: 10px;
}
.card-4{
  background-color: #f46a6a;
  padding: 30px 20px;
  border-radius: 10px;
}
.flex-grow-1, .text-w{
  color: #fff !important;
}
.flex-grow-1 p {
  font-size: 13px;
}

.avt-1{
  box-shadow: -3px -3px 7px -2px #909fec, 3px 3px 7px -3px #344598;
  background: hsla(0,0%,100%,.1)!important;
  border-radius: 5px;
}
.avt-2{
  box-shadow: -3px -3px 7px -2px #98f1e9, 3px 3px 7px -3px #207269;
  background: hsla(0,0%,100%,.1)!important;
  border-radius: 5px;
}
.avt-3{
  box-shadow: -3px -3px 7px -2px #f3b999, 3px 3px 7px -3px #703b1e;
  background: hsla(0,0%,100%,.1)!important;
  border-radius: 5px;
}
.avt-4{
  box-shadow: -3px -3px 7px -2px #f5abab, 3px 3px 7px -3px #5e1b1b;
  background: hsla(0,0%,100%,.1)!important;
  border-radius: 5px;
}


.td-duAn {
  background-color: #556ee6;
}
.td-duAnHoanThanh {
  background-color: #34c38f;
}
.td-duAnTreHen {
  background-color: #f1b44c;
}
.td-duAnKhoKhan {
  background-color: #f46a6a;
}

.page-dashboard{
  margin-top: -10px;
}

.card-header{
  justify-content: space-between;
  flex-direction: row;
}

@media only screen and(max-width: 1024px){
  .card-header{
    flex-direction: column;
  }
}

.bg-bq-info{
  /*background: linear-gradient(45deg, #1a569e, #4bb8dd);*/
  background: rgba(26, 86, 158, 0.1);
  width: 100%;
  height: 100% !important;
  position: relative;
}
.bg-bq-info .card-title{
  margin-left: 10px;
  margin-top: 10px;
}

.bg-bq-info .card-img img{
  position: absolute;
  right: 20px;
  bottom: 20px;
  height: 200px;
}

@media only screen and (max-width: 1024px){
  .bg-bq-info .card-img img{
    height: 150px;
  }
}

@media only screen and (max-width: 768px){
  .bg-bq-info .card-img img{
    height: 100px;
  }
}
.bg-bq-info .text-box{
  /*background: linear-gradient(45deg, #1a569e, #4bb8dd);*/
  background: #1a569e;
  padding: 10px 20px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 50px;
  width: 200px;
}
.bg-bq-info .text-box .item-left {
  width: 35px;
  height: 35px;
  background-color: #fff;
  border-radius: 50px;
  color: #1a569e;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -10px;
}

.bg-bq-info .text-box .item-right {
  color: #fff;
  diplay: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}


.td-duAn {
  background-color: #556ee6;
}

.td-duAnHoanThanh {
  background-color: #34c38f;
}

.td-duAnTreHen {
  background-color: #f1b44c;
}

.td-duAnKhoKhan {
  background-color: #f46a6a;
}

.bg-bq-success{
  background: linear-gradient(45deg, #3faf22, #7bd36a);
}
.bg-bq-warning{
  background: linear-gradient(45deg, #bc7a22, #e5ae63);
}
.bg-bq-danger{
  background: linear-gradient(45deg, #bf2632, #d15b56);
}
</style>
